import { makeVar } from "@apollo/client";
import {
  IncomingSampleActions,
  useIncomingSampleState,
} from "features/IncomingSamples/state";
import { RunPageContextMenuHidden } from "features/Runs/components/Table/RunsTable";
import { IncomingSampleTaskTableEntryFragment } from "graphql/generated/schema-types";
import React, { useMemo } from "react";
import { contextMenu } from "react-contexify";
import { Row } from "react-table";

//Workaround to prevent dialog from opening when the context menu loses focus
export const IncomingSampleTaskContextMenuHidden = makeVar(true);

export const handleContextMenu =
  (
    selected: IncomingSampleTaskTableEntryFragment[],
    row?: Row<IncomingSampleTaskTableEntryFragment>
  ) =>
  (e: React.MouseEvent<HTMLTableRowElement>) => {
    e.preventDefault();
    row?.toggleRowSelected(true);
    const _selected = selected.includes(row!.original)
      ? selected
      : [...selected, row?.original];
    contextMenu.show({
      id: "IncomingSampleTaskTableContextMenu",
      event: e,
      props: {
        selected: _selected.map((s) => s?.incomingSampleTaskId),
      },
    });
    IncomingSampleTaskContextMenuHidden(false);
  };

export const useHandleRowClick = (): ((
  rowClicked?: Row<IncomingSampleTaskTableEntryFragment>
) => (e: React.MouseEvent) => void) => {
  const { incomingSampleDispatch } = useIncomingSampleState();
  return useMemo(
    () => (rowClicked?: Row<IncomingSampleTaskTableEntryFragment>) => () => {
      if (!rowClicked?.isGrouped && RunPageContextMenuHidden())
        incomingSampleDispatch({
          type: IncomingSampleActions.OPEN_TASK_SUMMARY,
          payload: {
            taskSummaryDialogState: {
              incomingSampleTaskId: rowClicked!.original.incomingSampleTaskId,
              open: true,
            },
          },
        });
    },
    [incomingSampleDispatch]
  );
};
